export const HEADER_HEIGHT = 60;
export const GNB_HEIGHT = 40;
export const CONTAINER_WIDTH = 414;

export const GRID_PADDING = 16;

// 영화리스트 pagination size
export const PAGING_SIZE = 10;
